import React, { useState, useEffect, useMemo } from 'react';
import { generateScheduleABC } from './ABCpdfGenerators';
// list of all US states for exemption scope selection

import { useParams } from 'react-router-dom';
import RealPropertySection from './RealPropertySection';
import RealPropertyModal from './RealPropertyModal';
import VehicleSection from './VehicleSection';
import VehicleModal from './VehicleModal';
import HouseholdGoodsSection from './HouseholdGoodsSection';
import HouseholdGoodsModal from './HouseholdGoodsModal';
import FinancialAssetsSection from './FinancialAssetsSection';
import FinancialAssetsModal from './FinancialAssetsModal';
import BusinessAssetsSection from './BusinessAssetsSection';
import BusinessAssetsModal from './BusinessAssetsModal';
import FarmAssetsSection from './FarmAssetsSection';
import FarmAssetsModal from './FarmAssetsModal';
import OtherAssetsSection from './OtherAssetsSection';
import MailingMatrixServiceSelector from '../components/MailingMatrixServiceSelector';
const STATE_CODES = [
  "AL","AK","AZ","AR","CA","CO","CT","DE","FL","GA",
  "HI","IA","ID","IL","IN","KS","KY","LA","MA","MD",
  "ME","MI","MN","MO","MS","MT","NC","ND","NE","NH",
  "NJ","NM","NV","NY","OH","OK","OR","PA","RI","SC",
  "SD","TN","TX","UT","VA","VT","WA","WI","WV","WY"
];
export default function ScheduleABC() {
  // Handler for generating Schedule ABC PDF
  
  const handleGenerate = async () => {
  try {
    setIsGenerating(true);

    // Always re-fetch fresh data immediately before generation
    const fresh = await refetchAllForGenerate();
    const savedScope = fresh.freshCase.exemption_scope || scope;

    const ABC = await generateScheduleABC({
      caseData: fresh.freshCase,
      realProperties: fresh.rp,
      vehicles: fresh.veh,
      householdItems: fresh.hh,
      financialAssets: fresh.fin,
      businessAssets: fresh.bus,
      farmAssets: fresh.farm,
      otherProperties: fresh.other,
      exemptions,
      scope: savedScope,
      selectedSchedules,
      data
    });

    if (ABC) {
      const link = document.createElement('a');
      link.href = URL.createObjectURL(ABC);
      link.download = 'ABC';
      link.click();
    }
  } catch (err) {
    console.error('Schedule ABC generation failed:', err);
    alert(err?.message || 'Failed to generate Schedule ABC');
  } finally {
    setIsGenerating(false);
  }
};
    const [data, setData] = useState({
      debtsD: [], // array of secured creditors
      debtsE: [], // array of priority creditors
      debtsF: [], // array of nonpriority unsecured creditors
      debtsG: [],
      notifyEF: [], // array of others to notify
      allDebts: [],
      caseInfo: {}, // case metadata: number, name, etc.
      amended: false,
      amendedReason: '',
      amendedCreditors: [],
      mailingMatrixService: null,
    });
  const [amended, setAmended] = useState(false);
  const [isGenerating, setIsGenerating] = useState(false);
  const [showAmendedModal, setShowAmendedModal] = useState(false);
  const [amendedReason, setAmendedReason] = useState('');
  const [amendStep, setAmendStep] = useState(1);
  const [amendedCreditors, setAmendedCreditors] = useState([]);
  const [mailingMatrixService, setMailingMatrixService] = useState(null);
  const [creditors, setCreditors] = useState([]);
  const [selectedSchedules, setSelectedSchedules] = useState(['all']);
  const { caseId } = useParams();
  const [realProperties, setRealProperties] = useState([]);
  const [vehicles, setVehicles] = useState([]);
  const [vehicleLoading, setVehicleLoading] = useState(true);
  const [vehicleError, setVehicleError] = useState(null);
  const [vehicleModalOpen, setVehicleModalOpen] = useState(false);
  const [editingVehicle, setEditingVehicle] = useState(null);
  const [householdItems, setHouseholdItems] = useState([]);
  const [householdLoading, setHouseholdLoading] = useState(true);
  const [householdError, setHouseholdError] = useState(null);
  const [householdModalOpen, setHouseholdModalOpen] = useState(false);
  const [editingHouseholdItem, setEditingHouseholdItem] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [modalOpen, setModalOpen] = useState(false);
  const [editingItem, setEditingItem] = useState(null);
  const [caseData, setCaseData] = useState(null);
  const [exemptions, setExemptions] = useState([]);
  const [scope, setScope] = useState('');
  const [scopeSaving, setScopeSaving] = useState(false);
  const [scopeMessage, setScopeMessage] = useState('');
  const [scopeSaveError, setScopeSaveError] = useState(false);
  const [financialAssets, setFinancialAssets] = useState({});
  const [businessAssets, setBusinessAssets] = useState({});
  const [farmAssets, setFarmAssets] = useState({});
  const [otherProperties, setOtherProperties] = useState([]);
  const [exemptionSummary, setExemptionSummary] = useState([]);
  const API_URL = process.env.REACT_APP_API_URL;
  const TOKEN = localStorage.getItem("accessToken");
  // Fetch real property data
  // Re-pull all asset & case data just-in-time for generation
const refetchAllForGenerate = async () => {
  const headers = { Authorization: `Bearer ${TOKEN}` };

  const [
    caseRes, rpRes, vehRes, hhRes, finRes, busRes, farmRes, otherRes
  ] = await Promise.all([
    fetch(`${API_URL}/case/${caseId}/overview/`, { headers }),
    fetch(`${API_URL}/case/${caseId}/list-real-properties/`, { headers }),
    fetch(`${API_URL}/case/${caseId}/list-vehicles/`, { headers }),
    fetch(`${API_URL}/case/${caseId}/list-household-items/`, { headers }),
    fetch(`${API_URL}/case/${caseId}/assets/`, { headers }),
    fetch(`${API_URL}/case/${caseId}/business-assets/`, { headers }),
    fetch(`${API_URL}/case/${caseId}/farm-assets/`, { headers }),
    fetch(`${API_URL}/case/${caseId}/other-properties/`, { headers }),
  ]);

  if (!caseRes.ok) throw new Error('Failed to re-fetch case overview');
  if (!rpRes.ok)   throw new Error('Failed to re-fetch real properties');
  if (!vehRes.ok)  throw new Error('Failed to re-fetch vehicles');
  if (!hhRes.ok)   throw new Error('Failed to re-fetch household items');
  if (!finRes.ok)  throw new Error('Failed to re-fetch financial assets');
  if (!busRes.ok)  throw new Error('Failed to re-fetch business assets');
  if (!farmRes.ok) throw new Error('Failed to re-fetch farm assets');
  if (!otherRes.ok)throw new Error('Failed to re-fetch other properties');

  const [
    freshCase, rp, veh, hh, finJson, busJson, farmJson, other
  ] = await Promise.all([
    caseRes.json(), rpRes.json(), vehRes.json(), hhRes.json(),
    finRes.json(), busRes.json(), farmRes.json(), otherRes.json()
  ]);

  const fin  = finJson?.financial || {};
  const bus  = busJson?.business  || {};
  const farm = farmJson?.farm     || {};

  // Update state so UI reflects latest data too
  setCaseData(freshCase);
  setRealProperties(rp);
  setVehicles(veh);
  setHouseholdItems(hh);
  setFinancialAssets(fin);
  setBusinessAssets(bus);
  setFarmAssets(farm);
  setOtherProperties(other);

  return { freshCase, rp, veh, hh, fin, bus, farm, other };
};
  useEffect(() => {
    async function fetchData() {
      try {
        const token = localStorage.getItem("accessToken");
        // Fetch case details and creditors in parallel
        const [caseRes, credRes] = await Promise.all([
          fetch(`${API_URL}/case/${caseId}/creditors/case-details/`, {
            headers: { Authorization: `Bearer ${token}` },
          }),
          fetch(`${API_URL}/case/${caseId}/creditors/`, {
            headers: { Authorization: `Bearer ${token}` },
          }),
        ]);
        if (!caseRes.ok || !credRes.ok) {
          console.error("Failed to fetch case or creditors");
          return;
        }
        const caseJson = await caseRes.json();
        const credJson = await credRes.json();
        // Populate data object
        setData({
          caseInfo: caseJson,
          debtsD: credJson.filter(d => d.debt_type === "secured"),
          debtsE: credJson.filter(d => d.debt_type === "priority"),
          debtsF: credJson.filter(d => d.debt_type === "unsecured"),
          debtsG: credJson.filter(d => d.debt_type === "executory"),
          notifyEF: credJson.filter(d => d.additional_notified),
          allDebts : credJson,
        });
        // Build a simple address list for UI display
        const creditorAddresses = credJson.map(c => ({
          name: c.account_name || c.name,
          street1: c.street1 || '',
          street2: c.street2 || '',
          city: c.city || '',
          state: c.state || '',
          zip_code: c.zip_code || '',
          codebtor: c.codebtor || '',
          codebtor_street1:c.codebtor_street1 || '',
          codebtor_street2:c.codebtor_street2 || '',
          codebtor_state:c.codebtor_state || '',
          codebtor_zip_code:c.codebtor_zip_code|| '',
          codebtor_city:c.codebtor_city||'',
        }));
        setCreditors(creditorAddresses);
      } catch (err) {
        console.error("Error fetching schedule data:", err);
      } finally {
        setLoading(false);
      }
    }
    fetchData();
  }, [caseId, API_URL]);
  useEffect(() => {
    async function fetchRealProperties() {
      try {
        const response = await fetch(
          `${API_URL}/case/${caseId}/list-real-properties/`,
          {
            headers: {
              'Authorization': `Bearer ${TOKEN}`,
            },
          }
        );
        if (!response.ok) throw new Error('Network response was not ok');
        const json = await response.json();
        setRealProperties(json);
      } catch (e) {
        console.error('Failed to fetch real properties', e);
        setError(e);
      } finally {
        setLoading(false);
      }
    }
    fetchRealProperties();
  }, [caseId]);

  // Fetch vehicle data
  useEffect(() => {
    async function fetchVehicles() {
      try {
        const res = await fetch(
          `${API_URL}/case/${caseId}/list-vehicles/`,
          { headers: { 'Authorization': `Bearer ${TOKEN}` } }
        );
        if (!res.ok) throw new Error('Network response was not ok');
        setVehicles(await res.json());
      } catch (e) {
        console.error('Failed to fetch vehicles', e);
        setVehicleError(e);
      } finally {
        setVehicleLoading(false);
      }
    }
    fetchVehicles();
  }, [caseId]);

  useEffect(() => {
    async function fetchHouseholdItems() {
      try {
        const res = await fetch(
          `${API_URL}/case/${caseId}/list-household-items/`,
          { headers: { 'Authorization': `Bearer ${TOKEN}` } }
        );
        if (!res.ok) throw new Error('Network response was not ok');
        setHouseholdItems(await res.json());
      } catch (e) {
        console.error('Failed to fetch household goods', e);
        setHouseholdError(e);
      } finally {
        setHouseholdLoading(false);
      }
    }
    fetchHouseholdItems();
  }, [caseId]);

  useEffect(() => {
    async function fetchCase() {
      try {
        const res = await fetch(`${API_URL}/case/${caseId}/overview/`, {
          headers: { 'Authorization': `Bearer ${TOKEN}` },
        });
        if (!res.ok) throw new Error('Failed to load case');
        setCaseData(await res.json());
      } catch (e) {
        console.error(e);
      }
    }
    fetchCase();
  }, [caseId]);

  useEffect(() => {
    if (!caseData) return;

    const caseDebtors = Array.isArray(caseData.debtors) ? caseData.debtors : [];
    const filingDebtor =
      caseDebtors.find(debtor => debtor.is_primary && debtor.is_filing) ||
      caseDebtors.find(debtor => debtor.is_filing) ||
      caseDebtors[0];
    const debtorState = String(filingDebtor?.state || '').toUpperCase();
    const rawSavedScope = String(caseData.exemption_scope || '').trim();
    const savedScope = rawSavedScope.toLowerCase() === 'federal'
      ? 'federal'
      : rawSavedScope.toUpperCase();

    setScope(savedScope || (STATE_CODES.includes(debtorState) ? debtorState : 'TN'));
  }, [caseData]);

  useEffect(() => {
    if (!scope) return;
    async function fetchExemptions() {
      try {
        const res = await fetch(
          `${API_URL}/exemptions/?state=${scope}`,
          { headers: { 'Authorization': `Bearer ${TOKEN}` } }
        );
        if (!res.ok) throw new Error('Failed to load exemptions');
        setExemptions(await res.json());
      } catch (e) {
        console.error('Failed to fetch exemptions', e);
      }
    }
    fetchExemptions();
  }, [scope]);

  // Fetch combined financial assets
  useEffect(() => {
    (async () => {
      const res = await fetch(
        `${API_URL}/case/${caseId}/assets/`,
        { headers: { Authorization: `Bearer ${TOKEN}` } }
      );
      if (!res.ok) return;
      const json = await res.json();
      setFinancialAssets(json.financial || {});
    })();
  }, [caseId]);

  // Fetch combined business assets
  useEffect(() => {
    (async () => {
      const res = await fetch(
        `${API_URL}/case/${caseId}/business-assets/`,
        { headers: { Authorization: `Bearer ${TOKEN}` } }
      );
      if (!res.ok) return;
      const json = await res.json();
      setBusinessAssets(json.business || {});
    })();
  }, [caseId]);

  // Fetch combined farm assets
  useEffect(() => {
    (async () => {
      const res = await fetch(
        `${API_URL}/case/${caseId}/farm-assets/`,
        { headers: { Authorization: `Bearer ${TOKEN}` } }
      );
      if (!res.ok) return;
      const json = await res.json();
      setFarmAssets(json.farm || {});
    })();
  }, [caseId]);

  // Fetch Other Properties
  useEffect(() => {
    (async () => {
      const res = await fetch(
        `${API_URL}/case/${caseId}/other-properties/`,
        { headers: { Authorization: `Bearer ${TOKEN}` } }
      );
      if (!res.ok) return;
      setOtherProperties(await res.json());
    })();
  }, [caseId]);

  // Recompute exemption summary whenever any asset or exemptions change
  useEffect(() => {
    // Gather all items across asset buckets
    const allItems = [
      ...realProperties,
      ...vehicles,
      ...householdItems,
      ...Object.values(financialAssets).flat(),
      ...Object.values(businessAssets).flat(),
      ...Object.values(farmAssets).flat(),
      ...otherProperties,
    ];

    // Tally exemption amounts by code
    const usageMap = allItems.reduce((map, item) => {
      const code = item.exemption_code || 'other';
      map[code] = (map[code] || 0) + (parseFloat(item.exemption_amount) || 0);
      return map;
    }, {});

    // Build summary array
    const summary = Object.entries(usageMap).map(([code, used]) => {
      const ex = exemptions.find(e => e.law === code);
      return {
        code,
        name: ex ? ex.asset_name : 'Other',
        used,
        limit: ex ? parseFloat(ex.limit) : null,
      };
    });
    
    setExemptionSummary(summary);
  }, [
    realProperties,
    vehicles,
    householdItems,
    financialAssets,
    businessAssets,
    farmAssets,
    otherProperties,
    exemptions,
  ]);

  // Handlers for add/edit/delete
  const openRealPropertyModal = item => {
    setEditingItem(item);
    setModalOpen(true);
  };

  const deleteRealProperty = async (id) => {
    if (!window.confirm('Are you sure you want to delete this property?')) return;
    try {
      const response = await fetch(
        `${API_URL}/case/${caseId}/real-properties/${id}/delete/`,
        {
          method: 'DELETE',
          headers: {
            'Authorization': `Bearer ${TOKEN}`,
          },
        }
      );
      if (!response.ok) throw new Error('Failed to delete property');
      setRealProperties(prev => prev.filter(p => p.id !== id));
    } catch (e) {
      console.error('Failed to delete real property', e);
      alert('Could not delete property.');
    }
  };

  const handleSaveProperty = saved => {
    setRealProperties(prev => {
      const exists = prev.find(p => p.id === saved.id);
      if (exists) {
        return prev.map(p => p.id === saved.id ? saved : p);
      } else {
        return [...prev, saved];
      }
    });
  };

  // Financial assets save
  const handleSaveFinancial = updatedFinancial => {
    setFinancialAssets(updatedFinancial);
  };

  // Business assets save
  const handleSaveBusiness = updatedBusiness => {
    setBusinessAssets(updatedBusiness);
  };

  // Farm assets save
  const handleSaveFarm = updatedFarm => {
    setFarmAssets(updatedFarm);
  };

  // Other properties save
  const handleSaveOther = updatedOther => {
    setOtherProperties(updatedOther);
  };

  const openVehicleModal = v => {
    setEditingVehicle(v);
    setVehicleModalOpen(true);
  };
  const deleteVehicle = async id => {
    if (!window.confirm('Delete this vehicle?')) return;
    try {
      const res = await fetch(
        `${API_URL}/case/${caseId}/vehicles/${id}/`,
        { method: 'DELETE', headers: { 'Authorization': `Bearer ${TOKEN}` } }
      );
      if (!res.ok) throw new Error();
      setVehicles(vs => {
        const filtered = vs.filter(v => v.id !== id);
        return filtered;
      });
    } catch {
      alert('Could not delete vehicle.');
    }
  };
  const handleSaveVehicle = saved => {
    setVehicles(vs => {
      const exists = vs.find(v => v.id === saved.id);
      return exists ? vs.map(v => v.id === saved.id ? saved : v) : [...vs, saved];
    });
  };

  const openHouseholdModal = item => {
    setEditingHouseholdItem(item);
    setHouseholdModalOpen(true);
  };
  const deleteHouseholdItem = async id => {
    if (!window.confirm('Delete this item?')) return;
    try {
      const res = await fetch(
        `${API_URL}/case/${caseId}/household-items/${id}/delete/`,
        { method: 'DELETE', headers: { 'Authorization': `Bearer ${TOKEN}` } }
      );
      if (!res.ok) throw new Error();
      setHouseholdItems(prev => prev.filter(i => i.id !== id));
    } catch {
      alert('Could not delete item.');
    }
  };
  const handleSaveHouseholdItem = saved => {
    setHouseholdItems(prev => {
      const exists = prev.find(i => i.id === saved.id);
      return exists ? prev.map(i => i.id === saved.id ? saved : i) : [...prev, saved];
    });
  };

  const handleScopeChange = async event => {
    const nextScope = event.target.value;
    const previousScope = scope;

    setScope(nextScope);
    setScopeSaving(true);
    setScopeMessage('');
    setScopeSaveError(false);

    try {
      const response = await fetch(`${API_URL}/case/${caseId}/`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${TOKEN}`,
        },
        body: JSON.stringify({ exemption_scope: nextScope }),
      });
      const payload = await response.json().catch(() => ({}));

      if (!response.ok) {
        throw new Error(payload.error || 'Could not save the exemption set.');
      }

      setCaseData(current => current
        ? { ...current, exemption_scope: nextScope }
        : payload
      );
      setScopeMessage('Exemption set saved.');
    } catch (saveError) {
      console.error('Failed to save exemption set', saveError);
      setScope(previousScope);
      setScopeSaveError(true);
      setScopeMessage(saveError.message || 'Could not save the exemption set.');
    } finally {
      setScopeSaving(false);
    }
  };

  if (loading) return <div>Loading Real Property…</div>;
  if (error)   return <div className="text-red-600">Error loading real properties.</div>;

  return (
    <div className="p-6">
          {showAmendedModal && (
        <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
          <div className="bg-white p-6 rounded shadow max-w-md w-full">
            {amendStep === 1 ? (
              <>
                <h3 className="text-lg font-semibold mb-2">Reason for Amendment</h3>
                <textarea
                  value={amendedReason}
                  onChange={e => setAmendedReason(e.target.value)}
                  className="w-full border rounded p-2"
                  rows={4}
                />
                <div className="mt-4 flex justify-end">
                  <button
                    onClick={() => setAmendStep(2)}
                    className="px-4 py-2 bg-blue-600 text-white rounded"
                  >
                    Next
                  </button>
                </div>
              </>
            ) : (
              <>
                <h3 className="text-lg font-semibold mb-2">Select Creditors to Serve</h3>
                <MailingMatrixServiceSelector
                  caseId={caseId}
                  value={mailingMatrixService}
                  onChange={service => {
                    setMailingMatrixService(service);
                    setAmendedCreditors(
                      service?.enabled
                        ? (service.recipients || []).map(recipient => ({ ...recipient, method: service.method || 'USM' }))
                        : []
                    );
                  }}
                />
                {!mailingMatrixService?.enabled && <>
                <button
                  onClick={() =>
                    setAmendedCreditors(creditors.map(c => ({ ...c, method: 'USM' })))
                  }
                  className="text-sm text-blue-600 mb-2"
                >
                  Select All as USM
                </button>
                <button
                  onClick={() => setAmendedCreditors([])}
                  className="ml-4 text-sm text-red-600 mb-2"
                >
                  Remove All
                </button>
                <div className="max-h-64 overflow-y-auto mb-4 border">
                  {creditors.map((c, idx) => {
                    const selected = amendedCreditors.find(ac => ac.name === c.name);
                    return (
                      <div key={idx} className="flex items-center justify-between p-2 border-b">
                        <div className="flex-1">
                          <div className="font-medium">{c.name}</div>
                          <div className="text-sm text-gray-500">
                            {c.street1}{c.street2?.trim() ? `, ${c.street2}` : ''}, {c.city}, {c.state} {c.zip_code}
                          </div>
                        </div>
                        <select
                          value={selected?.method || ''}
                          onChange={e => {
                            const method = e.target.value;
                            setAmendedCreditors(prev => {
                              const exists = prev.find(ac => ac.name === c.name);
                              console.log(amendedCreditors)
                              if (exists) {
                                return prev.map(ac =>
                                  ac.name === c.name ? { ...ac, method } : ac
                                );
                              }
                              return [...prev, { ...c, method }];
                            });
                          }}
                          className="border rounded px-2 py-1"
                        >
                          <option value="">None</option>
                          <option value="USM">USM</option>
                          <option value="Certified">Certified</option>
                        </select>
                      </div>
                    );
                  })}
                </div>
                </>}
                <div className="flex justify-between">
                  <button
                    onClick={() => setAmendStep(1)}
                    className="px-4 py-2 bg-gray-200 rounded"
                  >
                    Back
                  </button>
                  <button
                    onClick={() => {
                      setShowAmendedModal(false);
                      setData({
                        ...data,
                        amendedReason,
                        amendedCreditors,
                        mailingMatrixService,
                      });
                      console.log(data)
                    }}
                    className="px-4 py-2 bg-green-600 text-white rounded"
                  >
                    Done
                  </button>
                </div>
              </>
            )}
          </div>
        </div>
      )}
      <h1 className="text-2xl font-bold mb-4">Schedule ABC: Assets and Exemptions</h1>
      <div className="mb-4">
        <label htmlFor="scope-select" className="block text-sm font-medium text-gray-700">
          Exemption Set
        </label>
        <select
          id="scope-select"
          value={scope}
          onChange={handleScopeChange}
          disabled={scopeSaving || !caseData}
          className="mt-1 block w-1/3 p-2 border rounded"
        >
          <option value="" disabled>Select set...</option>
          <option value="federal">Federal</option>
          {STATE_CODES.map(code => (
            <option key={code} value={code}>
              {code}
            </option>
          ))}
        </select>
        {(scopeSaving || scopeMessage) && (
          <p className={`mt-1 text-sm ${scopeSaveError ? 'text-red-600' : 'text-gray-500'}`}>
            {scopeSaving ? 'Saving exemption set…' : scopeMessage}
          </p>
        )}
      </div>
      {/* Exemptions Summary */}
      <div className="mb-6">
        <h2 className="text-lg font-medium mb-2">Exemptions Summary</h2>
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
          {exemptionSummary.map(item => (
            <div key={item.code} className="p-4 bg-gray-50 border rounded">
              <p className="font-semibold">
                {item.name} <span className="text-xs text-gray-500">({item.code})</span>
              </p>
              <p className="text-sm">
                Used: ${item.used.toFixed(2)}
                {item.limit !== null && ` / $${item.limit.toFixed(2)}`}
              </p>
            </div>
          ))}
        </div>
      </div>
      <RealPropertySection
        items={realProperties}
        caseId={caseId}
        onAdd={() => openRealPropertyModal(null)}
        onEdit={item => openRealPropertyModal(item)}
        onDelete={deleteRealProperty}
        onChange={setRealProperties}
      />
      <RealPropertyModal
        isOpen={modalOpen}
        onClose={() => setModalOpen(false)}
        caseId={caseId}
        item={editingItem}
        onSave={handleSaveProperty}
        exemptions={exemptions}
      />
      {/* Vehicles */}
      <VehicleSection
        vehicles={vehicles}
        loading={vehicleLoading}
        error={vehicleError}
        caseId={caseId}
        onAdd={() => openVehicleModal(null)}
        onEdit={openVehicleModal}
        onDelete={deleteVehicle}
        onChange={setVehicles}
      />
      <VehicleModal
        isOpen={vehicleModalOpen}
        onClose={() => setVehicleModalOpen(false)}
        caseId={caseId}
        item={editingVehicle}
        onSave={handleSaveVehicle}
        exemptions={exemptions}
        scope={scope}
      />
      <HouseholdGoodsSection
        items={householdItems}
        loading={householdLoading}
        error={householdError}
        onAdd={() => openHouseholdModal(null)}
        onEdit={openHouseholdModal}
        onDelete={deleteHouseholdItem}
        onChange={setHouseholdItems}
      />
      <HouseholdGoodsModal
        isOpen={householdModalOpen}
        onClose={() => setHouseholdModalOpen(false)}
        caseId={caseId}
        item={editingHouseholdItem}
        onSave={handleSaveHouseholdItem}
        exemptions={exemptions}
        scope={scope}
      />
      {/* Financial Assets Section */}
      <FinancialAssetsSection
        caseId={caseId}
        assets={financialAssets}
        exemptions={exemptions}
        scope={scope}
        onChange={data => setFinancialAssets(data)}
        onSave={handleSaveFinancial}
      />
      {/* Business Assets Section */}
      <BusinessAssetsSection
        caseId={caseId}
        assets={businessAssets}
        exemptions={exemptions}
        scope={scope}
        onChange={data => setBusinessAssets(data)}
        onSave={handleSaveBusiness}
      />
      {/* Farm Assets Section */}
      <FarmAssetsSection
        caseId={caseId}
        assets={farmAssets}
        exemptions={exemptions}
        scope={scope}
        onChange={data => setFarmAssets(data)}
        onSave={handleSaveFarm}
      />
      <OtherAssetsSection
        caseId={caseId}
        items={otherProperties}
        exemptions={exemptions}
        scope={scope}
        onChange={data => setOtherProperties(data)}
        onSave={handleSaveOther}
      />
      {/* Generate Schedule ABC PDF button */}
              <div className="flex flex-wrap items-center space-x-4 mb-4">
          {['AB','C','all'].map(type => {
            const isAll = type === 'all';
            const isSel = selectedSchedules.includes(type);
            return (
              <button
                key={type}
                type="button"
                onClick={() => {
                  setSelectedSchedules(prev => {
                    // clicking “All” resets to just ['all']
                    if (isAll) return ['all'];
                    // otherwise remove 'all'
                    const withoutAll = prev.filter(s => s !== 'all');
                    // toggle this type
                    if (withoutAll.includes(type)) {
                      return withoutAll.filter(s => s !== type);
                    } else {
                      return [...withoutAll, type];
                    }
                  });
                }}
                className={`px-4 py-2 rounded ${
                  isSel ? 'bg-indigo-600 text-white' : 'bg-gray-200 text-gray-700'
                }`}
              >
                {isAll ? 'All' : `Schedule ${type}`}
              </button>
            );
          })}
                        <div className="flex items-center mb-4">
          <input
            type="checkbox"
            checked={data.amended}
            onChange={e => {
              const checked = e.target.checked;
              setData({ ...data, amended: checked });
              if (checked) {
                setShowAmendedModal(true);
                setAmendStep(1);
              }
            }}
            className="h-4 w-4 text-indigo-600 border-gray-300 rounded"
          />
          <label className="ml-2 text-sm text-gray-700">Amended Filing</label>
        </div>
 </div>
      <div className="mt-8 flex justify-end">
<button
  className={`px-6 py-2 rounded text-white ${isGenerating || scopeSaving || !scope ? 'bg-blue-300 cursor-not-allowed' : 'bg-blue-700 hover:bg-blue-800'}`}
  onClick={handleGenerate}
  disabled={isGenerating || scopeSaving || !scope}
>
  {isGenerating ? 'Generating…' : scopeSaving ? 'Saving exemption set…' : 'Generate Schedule ABC PDF'}
</button>
      </div>
    </div>
  );
}
      {/* Expense Section */}
      {/* If you render ExpenseSection here, pass caseData as prop */}
      {/* <ExpenseSection caseId={caseId} caseData={caseData} /> */}
